function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 13.0926C8.44928 13.0926 7.60143 12.7453 6.97631 12.1272C6.35119 11.509 6 10.6705 6 9.79627C6 8.92201 6.35119 8.08357 6.97631 7.46537C7.60143 6.84718 8.44928 6.49989 9.33333 6.49989C10.2174 6.49989 11.0652 6.84718 11.6904 7.46537C12.3155 8.08357 12.6667 8.92201 12.6667 9.79627C12.6667 10.2292 12.5804 10.6578 12.4129 11.0577C12.2454 11.4577 11.9999 11.8211 11.6904 12.1272C11.3808 12.4333 11.0134 12.6761 10.6089 12.8417C10.2045 13.0074 9.77107 13.0926 9.33333 13.0926ZM9.33333 0.566406C6.85798 0.566406 4.48401 1.53884 2.73367 3.26977C0.98333 5.0007 0 7.34836 0 9.79627C0 16.7187 9.33333 26.9374 9.33333 26.9374C9.33333 26.9374 18.6667 16.7187 18.6667 9.79627C18.6667 7.34836 17.6833 5.0007 15.933 3.26977C14.1827 1.53884 11.8087 0.566406 9.33333 0.566406Z",
  fill: "#12A7D8"
});

var SvgBlueMarker = function SvgBlueMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blueMarker.ce6d8462.svg";
export { ForwardRef as ReactComponent };